import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { DebounceInputDirective } from '../../../directives/debounce-input.directive';

@Component({
  selector: 'app-search-input',
  standalone: true,
  imports: [
    NgIf,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    NgClass,
    DebounceInputDirective,
  ],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent {
  @Input() placeholder = 'durchsuchen ...';
  @Input() label = '';
  @Input() searchValue = '';
  @Input() showClearButton = true;
  @Input() disabled = false;
  @Input() inputStyleClass = '';
  @Input() autofocus = false;
  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('searchWord') searchInput!: ElementRef;

  /**
   * Triggers a search event emitting the provided search value.
   *
   * @param {string} value - The search query or input value to emit.
   * @return {void}
   */
  onSearch(value: string): void {
    this.search.emit(value);
  }

  /**
   * Clears the value of the search input field and triggers the search with an empty string.
   *
   * @return {void} This method does not return any value.
   */
  clearInput(): void {
    this.searchInput.nativeElement.value = '';
    this.onSearch('');
  }
}
